export enum actionTypeKeys {
  APPT_CREATED_BY = "APPT_CREATED_BY",
  APPT_HOLD_EXPIRED = "APPT_HOLD_EXPIRED",
  APPT_HOLD_TIME_REMAINING_CHANGED = "APPT_HOLD_TIME_REMAINING_CHANGED",
  AUTHENTICATION_FAILED = "AUTHENTICATION_FAILED",
  AUTHENTICATION_SUCCESS = "AUTHENTICATION_SUCCESS",
  BRANCH_SELECTED = "BRANCH_SELECTED",
  CATEGORY_SELECTED = "CATEGORY_SELECTED",
  CANCEL_APPOINTMENT_SUCCESS = "CANCEL_APPOINTMENT_SUCCESS",
  CLEAR_APPOINTMENT = "CLEAR_APPOINTMENT",
  CLEAR_APPOINTMENT_VALUES = "CLEAR_APPOINTMENT_VALUES",
  CLEAR_TIME_SLOTS = "CLEAR_TIME_SLOTS",
  CLOSE_APP_AFTER_APPT = "CLOSE_APP_AFTER_APPT",
  CUSTOMER_PREFERENCES_UPDATED_SUCCESS = "CUSTOMER_PREFERENCES_UPDATED_SUCCESS",
  GET_APPOINTMENT_SUCCESS = "GET_APPOINTMENT_SUCCESS",
  GET_APPT_SURVEY_SUCCESS = "GET_APPT_SURVEY_SUCCESS",
  GUEST_SIGN_IN = "GUEST_SIGN_IN",
  LOAD_ALL_BRANCH_HOURS_SUCCESS = "LOAD_ALL_BRANCH_HOURS_SUCCESS",
  LOAD_APP_SETTINGS_SUCCESS = "LOAD_APP_SETTINGS_SUCCESS",
  LOAD_APPOINTMENTS_SUCCESS = "LOAD_APPOINTMENTS_SUCCESS",
  LOAD_BRANCHES_SUCCESS = "LOAD_BRANCHES_SUCCESS",
  LOAD_CUSTOMER_PREFERENCES_SUCCESS = "LOAD_CUSTOMER_PREFERENCES_SUCCESS",
  LOAD_REPRESENTATIVES_SUCCESS = "LOAD_REPRESENTATIVES_SUCCESS",
  LOAD_TIME_SLOTS_SUCCESS = "LOAD_TIME_SLOTS_SUCCESS",
  LOGOUT_SUCCESS = "LOGOUT_SUCCESS",
  PATCH_APPT_SURVEY_SUCCESS = "PATCH_APPT_SURVEY_SUCCESS",
  REASON_SELECTED = "REASON_SELECTED",
  SCHEDULE_APPOINTMENT_SUCCESS = "SCHEDULE_APPOINTMENT_SUCCESS",
  SCHEDULING_APPOINTMENT = "SCHEDULING_APPOINTMENT",
  SERVICE_REP_SELECTED = "SERVICE_REP_SELECTED",
  SERVICE_REP_SIGN_IN_SUCCESS = "SERVICE_REP_SIGN_IN_SUCCESS",
  SET_APPT_AUDIT = "SET_APPT_AUDIT",
  SET_ATTEMPTED_APPT = "SET_ATTEMPTED_APPT",
  SET_APPT_REP_SELECT_CODE = "SET_APPT_REP_SELECT_CODE",
  SET_APP_TITLE_BAR = "LOAD_APP_TITLE_BAR",
  SET_APPOINTMENT_ADDITIONAL_INFO = "SET_APPOINTMENT_ADDITIONAL_INFO",
  SET_DEEP_LINK = "SET_DEEP_LINK",
  TIME_SLOT_SELECTED = "TIME_SLOT_SELECTED",
  TRANSFER_APPOINTMENT_SUCCESS = "TRANSFER_APPOINTMENT_SUCCESS",
  UPDATE_DEEP_LINK_STATUS = "UPDATE_DEEP_LINK_STATUS"
}
